import { HelpCircle } from 'lucide-react'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'

const FAQ_ITEMS = [
  {
    pregunta: '¿Qué incluye una campaña multicanal?',
    respuesta:
      'Incluye la planificación, creación de contenido, segmentación, ejecución y análisis de acciones en canales como WhatsApp, email marketing, SMS. Todo orientado a lograr mayor alcance e impacto en médicos de nuestra base.',
  },
  {
    pregunta: '¿Qué tipo de base de médicos manejan?',
    respuesta:
      'Contamos con una base segmentada de médicos validados, organizada por especialidad, ubicación geográfica, tipo de práctica y áreas terapéuticas de interés. Esto nos permite llegar al perfil ideal para cada marca.',
  },
  {
    pregunta: '¿Qué diferencias ofrece su servicio?',
    respuesta:
      'Base actualizada, validada y con consentimientos informados de médicos, enfoque científico-comercial, automatización inteligente y segmentación avanzada, contenido médico-educativo de alto valor, y reportes claros orientados a resultados.',
  },
  {
    pregunta: '¿Hay planes personalizados?',
    respuesta:
      'Sí. Adaptamos el servicio según objetivos, especialidad médica, frecuencia de contacto y presupuesto.',
  },
]

export function PricingFAQ() {
  return (
    <div className="bg-white rounded-lg border border-gray-300 p-4 lg:p-6">
      <h2 className="text-lg font-bold text-gray-900 mb-3 flex items-center">
        <HelpCircle className="w-5 h-5 text-teal-500 mr-2" />
        Preguntas frecuentes
      </h2>
      <Accordion type="single" collapsible className="w-full">
        {FAQ_ITEMS.map((item, i) => (
          <AccordionItem key={i} value={`faq-${i}`} className="border-b border-gray-200">
            <AccordionTrigger className="text-left text-sm font-semibold text-gray-900 py-2">
              {item.pregunta}
            </AccordionTrigger>
            <AccordionContent className="text-xs text-gray-600 pb-2">
              {item.respuesta}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  )
}
